import { render, staticRenderFns } from "./afterservice.vue?vue&type=template&id=7dbf5f57"
import script from "./afterservice.vue?vue&type=script&lang=js"
export * from "./afterservice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports